<template>
  <div class="c-tab-placement">
    <div class="o-grid o-grid--gutter-large">
      <div class="o-grid__group">
        <div class="o-grid__item  o-grid__item--4">
          <div class="o-grid o-grid--gutter-large">
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--12">
                <CallCenterAEDreport></CallCenterAEDreport>
              </div>
            </div>
          </div>
        </div>
        <div class="o-grid__item  o-grid__item--4">
          <CallCenterAEDmap></CallCenterAEDmap>
        </div>
        <div class="o-grid__item  o-grid__item--4">
          <CallCenterAEDstatus></CallCenterAEDstatus>
        </div>
        <div class="o-grid__item  o-grid__item--12">
          <CallCenterAEDhistory></CallCenterAEDhistory>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CallCenterAEDreport from "@/components/AED/aed-report.vue";
import CallCenterAEDmap from "@/components/AED/aed-map-report.vue";
import CallCenterAEDstatus from "@/components/AED/aed-status-report.vue";
import CallCenterAEDhistory from "@/components/AED/aed-report-history.vue";
export default {
  name: "c-tab-report",
  components: {
    CallCenterAEDreport,
    CallCenterAEDmap,
    CallCenterAEDstatus,
    CallCenterAEDhistory
  }
};
</script>
<style lang="scss">
.c-tab-report {
}
</style>
